document.addEventListener("DOMContentLoaded", function () {
  const giftSection = document.getElementById("gift-with-purchase");
  const giftChoices = giftSection.querySelectorAll(".js-gift-choice");
  if (giftChoices.length) {
    giftChoices.forEach((choice) => {
      choice.addEventListener("click", () => {
        giftChoices.forEach((allChoices) => {
          allChoices.classList.remove("js-selected-gift");
        });

        choice.classList.add("js-selected-gift");
      });
    });
  }
});

document.addEventListener("cart:change", (event) => {
  if (
    event.detail.baseEvent == "variant:add" &&
    event.detail.cart.item_count > 0
  ) {
    //check if gift needs to be added
    const giftSection = document.getElementById("gift-with-purchase");
    if (giftSection) {
      const selectedGift = giftSection.querySelector(".js-selected-gift");
      const giftId = selectedGift.getAttribute("data-variant-id");
      const giftTier = selectedGift.getAttribute("data-gwp-tier");
      const mainProduct = selectedGift.getAttribute("data-main-product");
      

      if (giftId) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: giftId,
            quantity: 1,
            properties: {
              _tier: giftTier,
              _main_product: mainProduct,
            },
          }),
        })
          .then(() => {
            window.cartUpdated = true;
            document.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  } else if (
    event.detail.baseEvent == "line-item:change" &&
    event.detail.cart.item_count > 0
  ) {
    //check if gift needs to be removed
    event.detail.cart.items.forEach((cartItem) => {
      let highestTier = 0;
      if (cartItem.properties._tier) {
        if (cartItem.properties._tier < highestTier) {
          removeItem(cartItem.variant_id);
        } else {
          highestTier = cartItem.properties._tier;
          let mainProdInCart = false;
          event.detail.cart.items.forEach((allCartItem) => {
            if (cartItem.properties._main_product == allCartItem.variant_id) {
              mainProdInCart = true;
            }
          });

          if (!mainProdInCart) {
            removeItem(cartItem.variant_id);
          }
        }
      }
    });
  }
});

function removeItem(id) {
  if (id) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: id.toString(),
        quantity: 0,
      }),
    })
      .then(() => {
        window.cartUpdated = true;
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
